<script>
  import { onMount } from "svelte";
  import LoadingBasic from "./loading-basic.svelte";

  let {
    class: classInput,
    ref = $bindable(null),
    children,
    ...restProps
  } = $props();

  let bShowMessage = $state(false);

  onMount(() => {
    const timer = setTimeout(() => {
      bShowMessage = true;
    }, 2000);

    return () => clearTimeout(timer); // opruimen als component wordt unmounted
  });
</script>

<div style="display: flex; flex-direction: column; align-items: center;">
  <LoadingBasic />
  {#if bShowMessage}
    <p style="margin-top: 0.5rem; font-size: 0.9rem; color: #a8a7a7;">
      uw verzoek wordt verwerkt
    </p>
  {/if}
</div>

